module.exports = __webpack_public_path__ + "static/media/consulta_rapida_e_recomendacoes.fa233e1e.svg";